/**
 * @generated SignedSource<<346dab15d50b5e303123a67088d943f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarPromotionForm_transaction$data = {
  readonly mostRecentOffer: {
    readonly quantity: number | null;
  } | null;
  readonly promotions: ReadonlyArray<{
    readonly code: string | null;
    readonly customerSuccessMessage: string | null;
    readonly failureSource: {
      readonly sourceId: string | null;
    } | null;
    readonly hasBuyerError: boolean | null;
    readonly isInvalid: boolean | null;
    readonly ruleList: ReadonlyArray<{
      readonly apiType: string | null;
      readonly paymentMethodType?: string | null;
      readonly serviceId?: string | null;
    } | null> | null;
    readonly terms: string | null;
    readonly validationCode: string | null;
  } | null> | null;
  readonly " $fragmentType": "CheckoutSidebarPromotionForm_transaction";
};
export type CheckoutSidebarPromotionForm_transaction$key = {
  readonly " $data"?: CheckoutSidebarPromotionForm_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarPromotionForm_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarPromotionForm_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "promotions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInvalid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasBuyerError",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "terms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customerSuccessMessage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "validationCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FailureSource",
          "kind": "LinkedField",
          "name": "failureSource",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "ruleList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "apiType",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paymentMethodType",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodTypeRule",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "mostRecentOffer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "bff7a96a9e59a59ab158a66720918e90";

export default node;
